import { Poll, CreatePollRequest, VotePollRequest } from '../Types/poll';
import {
	getPollsForObject,
	getOnePoll,
	createPoll,
	updatePoll,
	deletePoll,
	votePoll,
	togglePollActive,
} from '../Services/poll';
import { useBizQuery } from './useBizQuery';
import { useBizMutation } from './useBizQuery';
import { ObjectType } from '../Types/base';

const QUERYKEY_POLLS_FOR_OBJECT = 'POLLS_FOR_OBJECT';
const QUERYKEY_ONE_POLL = 'ONE_POLL';

export const useGetPollsForObject = (objectType: ObjectType, objectId: number) => {
	const { data, statusState } = useBizQuery(
		[QUERYKEY_POLLS_FOR_OBJECT, objectType.toString(), objectId.toString()],
		() => getPollsForObject({ objectType, objectId })
	);
	return { polls: data, statusState };
};

export const useGetOnePoll = (pollId: number) => {
	const { data, statusState } = useBizQuery(
		[QUERYKEY_ONE_POLL, pollId.toString()],
		() => getOnePoll(pollId)
	);
	return { poll: data, statusState };
};

export const useCreatePoll = () => {
	const wrapperFn = (params: { poll: CreatePollRequest }) => {
		return createPoll(params.poll);
	};
	const { mutate, statusState, data } = useBizMutation(wrapperFn, {
		getQueryKeyForInvalidation: () => [[QUERYKEY_POLLS_FOR_OBJECT]],
	});

	return {
		createPoll: (poll: CreatePollRequest) => mutate({ poll }),
		result: data,
		statusState,
	};
};

export const useUpdatePoll = () => {
	const wrapperFn = (params: { poll: Poll }) => {
		return updatePoll(params.poll);
	};
	const { mutate, statusState, data } = useBizMutation(wrapperFn, {
		getQueryKeyForInvalidation: () => [[QUERYKEY_POLLS_FOR_OBJECT], [QUERYKEY_ONE_POLL]],
	});

	return {
		updatePoll: (poll: Poll) => mutate({ poll }),
		result: data,
		statusState,
	};
};

export const useDeletePoll = () => {
	const wrapperFn = (params: { pollId: number }) => {
		return deletePoll(params.pollId);
	};
	const { mutate, statusState } = useBizMutation(wrapperFn, {
		getQueryKeyForInvalidation: () => [[QUERYKEY_POLLS_FOR_OBJECT], [QUERYKEY_ONE_POLL]],
	});

	return {
		deletePoll: (pollId: number) => mutate({ pollId }),
		statusState,
	};
};

export const useVotePoll = () => {
	const wrapperFn = (params: { voteRequest: VotePollRequest }) => {
		return votePoll(params.voteRequest);
	};
	const { mutate, statusState, data } = useBizMutation(wrapperFn, {
		getQueryKeyForInvalidation: () => [[QUERYKEY_POLLS_FOR_OBJECT], [QUERYKEY_ONE_POLL]],
	});

	return {
		votePoll: (voteRequest: VotePollRequest) => mutate({ voteRequest }),
		result: data,
		statusState,
	};
};

export const useTogglePollActive = () => {
	const wrapperFn = (params: { pollId: number }) => {
		return togglePollActive(params.pollId);
	};
	const { mutate, statusState, data } = useBizMutation(wrapperFn, {
		getQueryKeyForInvalidation: () => [[QUERYKEY_POLLS_FOR_OBJECT], [QUERYKEY_ONE_POLL]],
	});

	return {
		togglePollActive: (pollId: number) => mutate({ pollId }),
		result: data,
		statusState,
	};
};